import moment from 'moment';
import { useCallback, useEffect, useState, useTransition } from 'react';

import { fetchListPeriods } from '~modules/period/api';
import { SectionWithPeriodDto } from '~modules/period/dto';

export function usePeriods(year?: number, month?: number) {
	const [list, setList] = useState<SectionWithPeriodDto[]>([]);
	const [map, setMap] = useState<Map<number, number | null>>(new Map());
	const [pending, startLoading] = useTransition();

	const isExpired = useCallback(
		(date: Date, sectionId?: number | null) => {
			const clonedDate = moment(date).toDate();
			if (!sectionId) return false;
			const period = map.get(sectionId);
			if (period === null || period === undefined) {
				return false;
			}
			clonedDate.setDate(clonedDate.getDate() + period);
			return clonedDate <= new Date();
		},
		[map],
	);

	const load = useCallback(() => {
		startLoading(async () => {
			const data = await fetchListPeriods(year, month);
			setMap(
				data.reduce((acc, curr) => {
					acc.set(curr.id!, curr.period!);
					return acc;
				}, new Map<number, number | null>()),
			);
			setList(data);
		});
	}, [year, month]);

	useEffect(() => {
		load();
	}, [load]);

	return { pending, list, isExpired, reload: load };
}
